module.exports = __webpack_public_path__ + "static/media/author-spot1.a1b39c33.png";


//////////////////
// WEBPACK FOOTER
// ./public/images/authorSpotlight/author-spot1.png
// module id = 1560
// module chunks = 1